const development={
   identity:
   {
       client_id: "js",
       authority: 'https:///identity.qa.umbai.africa',
       redirect_uri: 'http://localhost:8080/callback',
       post_logout_redirect_uri: 'http://localhost:8080/',
       silent_redirect_uri: 'http://localhost:8080/static/silent-renew.html',
       register:'https://localhost:44366/account/register'
   },
   isMobile:false,
   gateway:"http://localhost:7000/",
   credits:'http://localhost:7000/credits/ViewWalletBalance?',
   walletTransactions:'http://localhost:7000/credits/ViewWalletTransactions?',
   walletWithdrawal:'http://localhost:7000/credits/withdrawal',
   initiatePayment:'http://localhost:7000/payment/Payment/InitiatePayment',
   forgotpassword:'http://localhost:5061/api/account/ForgotPassword',
   passwordreset:'http://localhost:5061/api/account/PasswordReset',
   airtimeProduct:'http://localhost:7000/payment/AirTimeProducts/QueryAirTimeProduct',
   zesaProduct:'http://localhost:7000/payment/AirTimeProducts/QueryZesaProduct'
}

const production={
    identity:
    {
        client_id: "js",
        authority: 'https://identity.umbai.co.za',
        redirect_uri: 'https://avo.umbai.co.za/callback',
        post_logout_redirect_uri: 'https://avo.umbai.co.za/',
        silent_redirect_uri: 'https://avo.umbai.co.za/static/silent-renew.html',
        register:'https://identity.umbai.co.za/account/register'
    },
    isMobile:false,
    gateway:"https://gateway.umbai.co.za/",
    credits:'https://gateway.umbai.co.za/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.umbai.co.za/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.umbai.co.za/credits/withdrawal',
    initiatePayment:'https://gateway.umbai.co.za/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.umbai.co.za/api/account/ForgotPassword',
    passwordreset:'https://identity.umbai.co.za/api/account/PasswordReset',
    airtimeProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryZesaProduct'
 } 

 const staging={
    identity:
    {
        client_id: "js",
        authority: 'https://identity.globalhood.co.zw',
        redirect_uri: 'https://globalhood.co.zw/callback',
        post_logout_redirect_uri: 'https://globalhood.co.zw/',
        silent_redirect_uri: 'https://globalhood.co.zw/static/silent-renew.html',
        register:'https://identity.globalhood.co.zw/account/register'
    },
    isMobile:false,
    gateway:"https://gateway.globalhood.co.zw/",
    credits:'https://gateway.globalhood.co.zw/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.globalhood.co.zw/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.globalhood.co.zw/credits/withdrawal',
    initiatePayment:'https://gateway.globalhood.co.zw/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.globalhood.co.zw/api/account/ForgotPassword',
    passwordreset:'https://identity.globalhood.co.zw/api/account/PasswordReset',
    airtimeProduct:'https://gateway.globalhood.co.zw/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.globalhood.co.zw/payment/AirTimeProducts/QueryZesaProduct'
 }
 
 const mobile={
    identity:
    {
        client_id: "mobile",
        authority: 'https://identity.umbai.co.za',
        redirect_uri: 'com.umbai.app://umbai.co.za/callback',
        post_logout_redirect_uri: 'com.umbai.app://umbai.co.za/landing',
        silent_redirect_uri: 'com.umbai.app://umbai.co.za/static/silent-renew.html',
        register:'https://identity.umbai.co.za/account/register'
    },
    isMobile:true,
    gateway:"https://gateway.umbai.co.za/",
    credits:'https://gateway.umbai.co.za/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.umbai.co.za/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.umbai.co.za/credits/withdrawal',
    initiatePayment:'https://gateway.umbai.co.za/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.umbai.co.za/api/account/ForgotPassword',
    passwordreset:'https://identity.umbai.co.za/api/account/PasswordReset',
    airtimeProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryZesaProduct'
 }


 let config=process.env.NODE_ENV === 'production'?production:development;

 config=process.env.VUE_APP_ENV==='staging'?staging:config;

 config=process.env.VUE_APP_ENV==='mobile'?mobile:config;

 export  {config as default}